import { NgModule } from '@angular/core';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Network } from '@ionic-native/network';
import { CameraPreview, CameraPreviewPictureOptions, CameraPreviewOptions, CameraPreviewDimensions } from '@ionic-native/camera-preview';
import { PhotoLibrary } from '@ionic-native/photo-library';
import { File } from '@ionic-native/file';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicPageModule } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { OpenALPR, OpenALPROptions, OpenALPRResult } from '@ionic-native/openalpr';
import { Vibration } from '@ionic-native/vibration';

import { PXUpload2App } from './app.component';

import { PPListPage } from '../pages/pp-list/pp-list';
import { PPDetailPage } from '../pages/pp-list/pp-detail';
import { UESearchPage } from '../pages/ue-list/ue-search';
import { EinsatzplanListPage } from '../pages/einsatzplan/einsatzplan-list';
import { EinsatzplanDetailPage } from '../pages/einsatzplan/einsatzplan-detail';
import { EinsatzplanCreatePage } from '../pages/einsatzplan/einsatzplan-create';
import { UEDetailPage } from '../pages/ue-list/ue-detail';
import { UECreatePage } from '../pages/ue/ue-create';
import { UEUploadPage } from '../pages/ue/ue-upload';
import { UEEditPage } from '../pages/ue-list/ue-edit';
import { UEFiltersPage } from '../pages/ue-list/ue-filters';
import { AnzeigePipe } from '../pages/ue-list/anzeige-pipe';

import { AccountPage } from '../pages/account/account';
import { AccountHomePage } from '../pages/account/account-home';
import { LoginPage } from '../pages/login/login';
import { BlockingtimeListPage } from '../pages/blockingtime/blockingtime-list';
import { BlockingtimeDetailPage } from '../pages/blockingtime/blockingtime-detail';
import { BlockingtimeCreatePage } from '../pages/blockingtime/blockingtime-create';
import { BlockingtimeData } from '../providers/blockingtime-data';

import { NotificationListPage } from '../pages/notifications/notification-list';
import { NotificationDetailPage } from '../pages/notifications/notification-detail';
import { NotificationData } from '../providers/notification-data';

import { ParkkontrollenCreatePage } from '../pages/parkkontrollen/parkkontrollen-create';

import { KontrollenCreatePage } from '../pages/kontrollen/kontrollen-create';
import { KontrollenData } from '../pages/kontrollen/kontrollen-data';
import { KontrollenModel } from '../pages/kontrollen/kontrollen-model';


import { EinsatzplanData } from '../providers/einsatzplan-data';
import { ParplatzData } from '../providers/pp-data';
import { UEData } from '../providers/ue-data';
import { UserData } from '../providers/user-data';
import { CommonData } from '../providers/common-data';
import { KontrolleData } from '../providers/kontrolle-data';
import { CompletePPService } from '../providers/epautocomplete-service';
import { CompleteZoneService } from '../providers/zoneautocomplete-service';
import { GolinksData } from '../providers/golinks-data';
import { TasksData } from '../providers/tasks-data';

import { GenericModalPageModule } from '../pages/generic-modal/generic-modal.module';

import { UEModel } from '../pages/ue/ue-model';
import { AdminPage } from '../pages/admin/admin';
import { PbAdminPage } from '../pages/parkbewilligungen/pbadmin/pbadmin';
import { ParkbewilligungenData } from '../pages/parkbewilligungen/parkbewilligungen-data';
import { ParkbewilligungenListPage } from '../pages/parkbewilligungen/parkbewilligungen-list';
import { AntraegeListPage } from '../pages/parkbewilligungen/antraege/antraege-list';
import { ParkbewilligungenEditPage } from '../pages/parkbewilligungen/parkbewilligungen-edit';
import { PbactionsPage } from '../pages/parkbewilligungen/pbactions/pbactions';
import { PbKategorieactionsPage } from '../pages/parkbewilligungen/pbkategorieactions/pbkategorieactions';
import { PbkategorienPage } from '../pages/parkbewilligungen/pbkategorien/pbkategorien';
import { PbkategorienEditPage } from '../pages/parkbewilligungen/pbkategorien/pbkategorien-edit/pbkategorien-edit';
import { PbperiodenCreatePage } from '../pages/parkbewilligungen/pbperioden-create/pbperioden-create';
import { PbKategorieSelection } from '../pages/parkbewilligungen/pbkategorieselection/pbkategorieselection';
import { PbZonenData } from '../providers/pbzonen-data';
import { PbKundenData } from '../providers/pbkunden-data';
import { PbKundenSelection } from '../pages/parkbewilligungen/pbkundenselection/pbkundenselection';
import { PbTermination } from '../pages/parkbewilligungen/pbtermination/pbtermination';

import { PbzonenPage } from '../pages/parkbewilligungen/pbzonen/pbzonen';

import { PbZonenactionsPage } from '../pages/parkbewilligungen/pbzonenactions/pbzonenactions';
import { PbzonenEditPage } from '../pages/parkbewilligungen/pbzonen/pbzonen-edit/pbzonen-edit';

import { GolinksPage } from '../pages/parkbewilligungen/golinks/golinks';
import { GolinksEditPage } from '../pages/parkbewilligungen/golinks/golinks-edit/golinks-edit';

import { TasksPage } from '../pages/tasks/tasks';
import { TasksEditPage } from '../pages/tasks/tasks-edit/tasks-edit';

import { AdditionalfieldsData } from '../providers/additionalfields-data';


import { MomentModule } from 'angular2-moment';
import { Geolocation } from '@ionic-native/geolocation';
import { HttpModule } from '@angular/http';
import { Flashlight } from '@ionic-native/flashlight';
import { IonicImageViewerModule } from 'ionic-img-viewer';
import { Base64ToGallery } from '@ionic-native/base64-to-gallery';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { GoogleMaps } from "@ionic-native/google-maps";
import { ComponentsModule } from "../components/components.module";

import { EmployeeavalabilityData } from '../pages/employeeavailability/employeeavailability-data';
import { EmployeeavalabilityListPage } from '../pages/employeeavailability/employeeavailability-list';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeCh from '@angular/common/locales/de-CH';
import localeChExtra from '@angular/common/locales/extra/de-CH';

import { PipesModule } from '../pipes/pipes.module';
import { AppVersion } from '@ionic-native/app-version';

import { AutoCompleteModule } from 'ionic2-auto-complete';
import { MandantenData } from '../providers/mandanten-data';
import { LicenseplateProvider } from '../providers/licenseplate/licenseplate';
import { LicenseplateProviderNew } from '../providers/licenseplate/licenseplate_new';
import { HistoryData } from '../providers/history-data';
import { LogperiodicjobsData } from '../providers/logperiodicjobs-data';

import { ImageCropperModule } from 'ngx-image-cropper';

import { AgGridModule } from 'ag-grid-angular';
import { AllModules, Module } from '@ag-grid-enterprise/all-modules';
import { AgGridMobileDoubleClickDirective } from './ag-grid-mobile-double-click.directive'
import { DeviceDetectorModule } from 'ngx-device-detector';
import { QRCodeModule } from 'angularx-qrcode';

registerLocaleData(localeCh, localeChExtra);

@NgModule({
  declarations: [
    PXUpload2App,
    PPListPage,
    PPDetailPage,
    EinsatzplanListPage,
    EinsatzplanDetailPage,
    EinsatzplanCreatePage,
    BlockingtimeListPage,
    BlockingtimeDetailPage,
    BlockingtimeCreatePage,
    NotificationListPage,
    NotificationDetailPage,
    KontrollenCreatePage,
    ParkkontrollenCreatePage,
    UEEditPage,
    UESearchPage,
    UEDetailPage,
    UECreatePage,
    UEUploadPage,
    UEFiltersPage,
    AnzeigePipe,
    AccountPage,
    AccountHomePage,
    LoginPage,
    EmployeeavalabilityListPage
    ,ParkbewilligungenListPage
    ,PbperiodenCreatePage
    ,PbKategorieSelection
    ,PbKundenSelection
    ,PbTermination
    ,AntraegeListPage
    ,ParkbewilligungenEditPage
    , PbactionsPage
    , PbkategorienPage
    , PbKategorieactionsPage
    , PbkategorienEditPage
    , PbzonenPage
    , PbzonenEditPage    
    , PbZonenactionsPage
    , GolinksPage
    , GolinksEditPage
    , TasksPage
    , TasksEditPage
    , AgGridMobileDoubleClickDirective
    , AdminPage
    , PbAdminPage

  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(PXUpload2App),
    IonicStorageModule.forRoot(),
    IonicPageModule.forChild(UEDetailPage),
    MomentModule,
    IonicImageViewerModule,
    ComponentsModule
    , PipesModule
    , AutoCompleteModule
    , ImageCropperModule    
    , AgGridModule.withComponents([])
    , DeviceDetectorModule.forRoot()
    , QRCodeModule
    , GenericModalPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    PXUpload2App,
    PPListPage,
    PPDetailPage,
    UESearchPage,
    EinsatzplanListPage,
    EinsatzplanCreatePage,
    EinsatzplanDetailPage,
    BlockingtimeListPage,
    BlockingtimeDetailPage,
    BlockingtimeCreatePage,
    NotificationListPage,
    NotificationDetailPage,    
    KontrollenCreatePage,
    ParkkontrollenCreatePage,
    UEDetailPage,
    UECreatePage,
    UEUploadPage,
    UEEditPage,
    UEFiltersPage,
    AccountPage,
    AccountHomePage,
    LoginPage
    ,EmployeeavalabilityListPage
    ,ParkbewilligungenListPage
    ,PbperiodenCreatePage
    ,PbKategorieSelection
    ,PbKundenSelection
    ,AntraegeListPage
    ,ParkbewilligungenEditPage
    ,PbactionsPage
    , PbkategorienPage
    , PbKategorieactionsPage
    , PbkategorienEditPage
    , PbzonenPage
    , PbzonenEditPage    
    , PbZonenactionsPage
    , GolinksPage
    , GolinksEditPage
    , TasksPage
    , TasksEditPage    
    , AdminPage
    , PbAdminPage
    , PbTermination
  ],
  providers: [
                  Geolocation
                , ParplatzData
                , AdditionalfieldsData
                , UEData
                , EinsatzplanData
                , UserData
                , CommonData
                , UEModel
                //, Storage
                , BlockingtimeData
                , KontrollenData
                , KontrollenModel
                , NotificationData
                , StatusBar
                , SplashScreen
                , Network
                , CameraPreview
                , Camera
                , Vibration
                , BarcodeScanner
                , Flashlight
                , KontrolleData
                , ParkbewilligungenData
                , AdditionalfieldsData
                , Base64ToGallery
                , File
                , PhotoLibrary
                , GoogleMaps
                , EmployeeavalabilityData
                ,{ provide: LOCALE_ID, useValue: "de-CH" }
                , AppVersion
                ,CompletePPService
                , CompleteZoneService
                , OpenALPR
                , MandantenData,
                LicenseplateProvider
                ,LicenseplateProviderNew
                ,HistoryData
                , InAppBrowser
                , LogperiodicjobsData
                , PbZonenData
                , PbKundenData
                , GolinksData
                , TasksData  
                ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts